module.exports = __webpack_public_path__ + "statics/img/SmartLogistics-4.4bbf7a2d.png";